const FACEBOOK_EMBED_VIDEO = 'https://www.facebook.com/plugins/video';
const YOUTUBE_EMBED_VIDEO = 'https://www.youtube.com/embed';
export const isIframeVideo = (embedCode: string) => {
    return embedCode.includes(YOUTUBE_EMBED_VIDEO) || embedCode.includes(FACEBOOK_EMBED_VIDEO);
};

export const isFacebookEmbedVideo = (iframeUrl: string) => {
    return iframeUrl.includes(FACEBOOK_EMBED_VIDEO);
};

export const isInstagramEmbed = (embed: string) => {
    return embed.includes('data-instgrm-permalink');
};

export const getInstagramPermaLink = (embed: string) => {
    const permalinkRegEx =
        / data-instgrm-permalink="(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})" /;
    const permalinkMatch: RegExpMatchArray | null = embed.match(permalinkRegEx);

    return permalinkMatch ? permalinkMatch[1] : '';
};

export const isFacebookVideoPortrait = (iframeUrl: string) => {
    const widthRegEx = / width="([0-9]+)"/;
    const heightRegEx = / height="([0-9]+)"/;

    const widthMatch: RegExpMatchArray | null = iframeUrl.match(widthRegEx);
    const heightMatch: RegExpMatchArray | null = iframeUrl.match(heightRegEx);

    const width = widthMatch ? parseFloat(widthMatch[1]) : 0;
    const height = heightMatch ? parseFloat(heightMatch[1]) : 0;

    return width < height;
};
